import axiosInstance from '../config/axios.js';

const API_BASE = '/containers';

const containerService = {
  // Get all containers with optional filters and pagination
  getAll: async (page = null, perPage = 10, params = {}) => {
    const queryParams = page !== null
      ? { page, per_page: perPage, ...params }
      : { all: 'true', ...params };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all containers without pagination
  getAllContainers: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get container by ID
  getById: async (containerId) => {
    const response = await axiosInstance.get(`${API_BASE}/${containerId}`);
    return response.data;
  },

  // Get containers by client ID
  getByClientId: async (clientId) => {
    const response = await axiosInstance.get(`${API_BASE}/client/${clientId}`);
    return response.data;
  },

  // Create new container
  create: async (containerData) => {
    const response = await axiosInstance.post(API_BASE, containerData);
    return response.data;
  },

  // Update container
  update: async (containerId, containerData) => {
    const response = await axiosInstance.put(`${API_BASE}/${containerId}`, containerData);
    return response.data;
  },

  // Delete container
  delete: async (containerId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${containerId}`);
    return response.data;
  }
};

export default containerService;